import { pick } from '#layers/base/utils/pick'

export default defineNuxtRouteMiddleware(async (to) => {
  const { isLoggedIn, user, forceRefresh } = useAgsUser()

  if (!user.value && forceRefresh) {
    try {
      await forceRefresh()
    } catch (error) {
      // Silently handle errors during user refresh to prevent middleware failures
      console.error('Failed to refresh user in authGuard:', error)
    }
  }

  const localePath = (routePath: LinkList[keyof LinkList]['path']) => {
    const getLocalePath = useLocalePath()
    return getLocalePath(routePath) || routePath
  }

  const getProtectedRoutes = (exclude: (keyof LinkList)[] = []) => {
    const routes = Object.entries(
      pick(routeList, [
        'account',
        'orders',
        'orderDetail',
        'checkout',
        'user',
        'goldnerClub',
        'goldnerClubSubscribePage',
      ]),
    ).reduce((routeMap, [name, value]) => {
      if (exclude.some((routeName) => routeName === name)) {
        return routeMap
      }

      Object.assign(routeMap, { [name]: value })
      return routeMap
    }, {} as Partial<LinkList>)

    return Object.values(routes).map((it) => localePath(it.path))
  }

  const isGuest = !!user.value?.status?.isGuestCustomer
  const isProtectedRoute = getProtectedRoutes().some((path) => to.path === path)
  const isProtectedRouteForGuests =
    isGuest && getProtectedRoutes(['checkout']).some((path) => to.path === path)

  if (!isLoggedIn.value && isProtectedRoute) {
    return navigateTo({
      path: localePath(routeList.signin.path),
      query: {
        redirectUrl: to.fullPath,
      },
    })
  }

  if (isLoggedIn.value && isProtectedRouteForGuests) {
    const redirectPath = (to.query.redirectUrl as string) || routeList.home.path
    return navigateTo({ path: redirectPath })
  }
})
